var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{lat:43.5448, lng:-80.2482},"zoom":14,"map-type-id":"roadmap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }